import { Parameter } from "src/clients/flow-api";
import {
  FieldMatch,
  FieldTypes,
  SearchableField,
} from "src/flowGraph/canvasSearch/extractNodeFields";

const stringifyParameter = (parameter: Parameter) => {
  return [parameter.name, parameter.description, parameter.expr].join(", ");
};

const extractParameterFields = (parameters: Parameter[]): SearchableField[] => {
  return parameters.map((parameter) => ({
    id: parameter.name, // name is unique for params
    value: stringifyParameter(parameter),
  }));
};

export const findMatchingParameters = (
  parameters: Parameter[],
  searchTerm: string,
): FieldMatch[] => {
  if (!searchTerm) {
    return [];
  }

  const lowerSearchTerm = searchTerm.toLowerCase();
  const fields = extractParameterFields(parameters);

  return fields
    .filter((field) =>
      (field.value ?? "").toLowerCase().includes(lowerSearchTerm),
    )
    .map((field) => ({
      fieldType: FieldTypes.PARAM,
      fieldId: field.id,
      fieldValue: field.value ?? "",
    }));
};
